<template>
  <base-table-wrapper>
    <template #top-buttons>
      <router-link tag="button" :to="{ name: 'EXCMTeamCreate' }" class="mb-1 btn btn-sm btn-primary float-right">{{ $t('buttons.create') }}</router-link>
    </template>
    <template #filtering></template>
    <template #body>
      <Loader v-if="isLoading"></Loader>
      <div v-else-if="!isLoading && items.length < 1">
        {{$t('views.excmteam.list.noTeam')}}
      </div>
      <table v-else class="table table-sm table-striped table-hover">
        <thead>
        <tr>
          <th>{{$t('views.excmteam.list.name')}}</th>
          <th colspan="2" />
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in items" :key="item['@id']">
          <td>
            <router-link v-if="item" :to="{name: 'EXCMTeamShow', params: { id: item['@id'] }}">
            </router-link> {{ item['name'] }}
          </td>
          <td>
            <router-link :to="{name: 'EXCMTeamShow', params: { id: item['@id'] }}" class="float-right">
              <button class="btn btn-link fa fa-search" v-b-tooltip.hover :title="$t('buttons.goto')" aria-hidden="true" />
            </router-link>
            <router-link :to="{name: 'EXCMTeamUpdate', params: { id: item['@id'] }}" class="float-right">
              <button class="btn btn-link fa fa-pencil" v-b-tooltip.hover :title="$t('buttons.edit')" aria-hidden="true" />
            </router-link>
          </td>
        </tr>
        </tbody>
      </table>
      <pagination
        v-if="view"
        :view="view"
        @getPage="getPage($event)"
      ></pagination>
    </template>
  </base-table-wrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../Layout/Loader'
import addParamsToQuery from '@/utils/addParamsToQuery'
import Pagination from '../../Layout/Pagination'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'

export default {
  computed: mapGetters({
    deletedItem: 'excmteam/del/deleted',
    error: 'excmteam/list/error',
    items: 'excmteam/list/items',
    isLoading: 'excmteam/list/isLoading',
    view: 'excmteam/list/view'
  }),

  components: {
    Loader,
    Pagination,
    BaseTableWrapper
  },

  data () {
    return {
      searchParams: {
        state: 1
      }
    }
  },

  created () {
    let url = addParamsToQuery('e_x_c_m_teams', this.searchParams)
    this.getPage(url)
  },

  methods: mapActions({
    getPage: 'excmteam/list/default'
  })
}
</script>
